/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CoordinateSystem } from './CoordinateSystem';
import {
    CoordinateSystemFromJSON,
    CoordinateSystemFromJSONTyped,
    CoordinateSystemToJSON,
} from './CoordinateSystem';
import type { CreateOtherQaEquipmentDtoBrand1 } from './CreateOtherQaEquipmentDtoBrand1';
import {
    CreateOtherQaEquipmentDtoBrand1FromJSON,
    CreateOtherQaEquipmentDtoBrand1FromJSONTyped,
    CreateOtherQaEquipmentDtoBrand1ToJSON,
} from './CreateOtherQaEquipmentDtoBrand1';
import type { CreateOtherQaEquipmentDtoSingleDetectorConnectorType } from './CreateOtherQaEquipmentDtoSingleDetectorConnectorType';
import {
    CreateOtherQaEquipmentDtoSingleDetectorConnectorTypeFromJSON,
    CreateOtherQaEquipmentDtoSingleDetectorConnectorTypeFromJSONTyped,
    CreateOtherQaEquipmentDtoSingleDetectorConnectorTypeToJSON,
} from './CreateOtherQaEquipmentDtoSingleDetectorConnectorType';
import type { DeviceInterfaceType } from './DeviceInterfaceType';
import {
    DeviceInterfaceTypeFromJSON,
    DeviceInterfaceTypeFromJSONTyped,
    DeviceInterfaceTypeToJSON,
} from './DeviceInterfaceType';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { PossibleActionDto } from './PossibleActionDto';
import {
    PossibleActionDtoFromJSON,
    PossibleActionDtoFromJSONTyped,
    PossibleActionDtoToJSON,
} from './PossibleActionDto';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';
import type { QaEquipmentStateOfUse } from './QaEquipmentStateOfUse';
import {
    QaEquipmentStateOfUseFromJSON,
    QaEquipmentStateOfUseFromJSONTyped,
    QaEquipmentStateOfUseToJSON,
} from './QaEquipmentStateOfUse';
import type { QaEquipmentSubCategory } from './QaEquipmentSubCategory';
import {
    QaEquipmentSubCategoryFromJSON,
    QaEquipmentSubCategoryFromJSONTyped,
    QaEquipmentSubCategoryToJSON,
} from './QaEquipmentSubCategory';
import type { ReferencingObjectDto } from './ReferencingObjectDto';
import {
    ReferencingObjectDtoFromJSON,
    ReferencingObjectDtoFromJSONTyped,
    ReferencingObjectDtoToJSON,
} from './ReferencingObjectDto';
import type { RtSystemCategory } from './RtSystemCategory';
import {
    RtSystemCategoryFromJSON,
    RtSystemCategoryFromJSONTyped,
    RtSystemCategoryToJSON,
} from './RtSystemCategory';
import type { RtSystemManufacturer } from './RtSystemManufacturer';
import {
    RtSystemManufacturerFromJSON,
    RtSystemManufacturerFromJSONTyped,
    RtSystemManufacturerToJSON,
} from './RtSystemManufacturer';
import type { UserCatalogDto } from './UserCatalogDto';
import {
    UserCatalogDtoFromJSON,
    UserCatalogDtoFromJSONTyped,
    UserCatalogDtoToJSON,
} from './UserCatalogDto';
import type { WithSerialNumber } from './WithSerialNumber';
import {
    WithSerialNumberFromJSON,
    WithSerialNumberFromJSONTyped,
    WithSerialNumberToJSON,
} from './WithSerialNumber';

/**
 * 
 * @export
 * @interface OtherQaEquipmentDto
 */
export interface OtherQaEquipmentDto {
    /**
     * 
     * @type {string}
     * @memberof OtherQaEquipmentDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OtherQaEquipmentDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof OtherQaEquipmentDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof OtherQaEquipmentDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OtherQaEquipmentDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OtherQaEquipmentDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OtherQaEquipmentDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof OtherQaEquipmentDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OtherQaEquipmentDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof OtherQaEquipmentDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {Array<PossibleActionDto>}
     * @memberof OtherQaEquipmentDto
     */
    readonly possibleActions?: Array<PossibleActionDto> | null;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof OtherQaEquipmentDto
     */
    creatorUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof OtherQaEquipmentDto
     */
    lastModifierUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof OtherQaEquipmentDto
     */
    editingUser?: UserCatalogDto;
    /**
     * 
     * @type {string}
     * @memberof OtherQaEquipmentDto
     */
    editingTime?: string | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof OtherQaEquipmentDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof OtherQaEquipmentDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof OtherQaEquipmentDto
     */
    isReferenced?: boolean;
    /**
     * 
     * @type {Array<ReferencingObjectDto>}
     * @memberof OtherQaEquipmentDto
     */
    isReferencedBy?: Array<ReferencingObjectDto> | null;
    /**
     * 
     * @type {number}
     * @memberof OtherQaEquipmentDto
     */
    readonly deleterUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof OtherQaEquipmentDto
     */
    readonly deletionTime?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OtherQaEquipmentDto
     */
    readonly isDeleted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OtherQaEquipmentDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof OtherQaEquipmentDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OtherQaEquipmentDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OtherQaEquipmentDto
     */
    typeSpecification?: string | null;
    /**
     * 
     * @type {RtSystemCategory}
     * @memberof OtherQaEquipmentDto
     */
    category: RtSystemCategory;
    /**
     * 
     * @type {RtSystemManufacturer}
     * @memberof OtherQaEquipmentDto
     */
    manufacturer: RtSystemManufacturer;
    /**
     * 
     * @type {string}
     * @memberof OtherQaEquipmentDto
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof OtherQaEquipmentDto
     */
    subModel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OtherQaEquipmentDto
     */
    imageId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OtherQaEquipmentDto
     */
    isArchived?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OtherQaEquipmentDto
     */
    masterDeviceId?: string | null;
    /**
     * 
     * @type {WithSerialNumber}
     * @memberof OtherQaEquipmentDto
     */
    withSerialNumber?: WithSerialNumber;
    /**
     * 
     * @type {string}
     * @memberof OtherQaEquipmentDto
     */
    typeNumber?: string | null;
    /**
     * 
     * @type {CreateOtherQaEquipmentDtoBrand1}
     * @memberof OtherQaEquipmentDto
     */
    brand1?: CreateOtherQaEquipmentDtoBrand1 | null;
    /**
     * 
     * @type {CreateOtherQaEquipmentDtoSingleDetectorConnectorType}
     * @memberof OtherQaEquipmentDto
     */
    singleDetectorConnectorType?: CreateOtherQaEquipmentDtoSingleDetectorConnectorType | null;
    /**
     * 
     * @type {DeviceInterfaceType}
     * @memberof OtherQaEquipmentDto
     */
    deviceInterfaceType?: DeviceInterfaceType;
    /**
     * 
     * @type {QaEquipmentSubCategory}
     * @memberof OtherQaEquipmentDto
     */
    subCategory: QaEquipmentSubCategory;
    /**
     * 
     * @type {CoordinateSystem}
     * @memberof OtherQaEquipmentDto
     */
    coordinateSystem?: CoordinateSystem;
    /**
     * 
     * @type {QaEquipmentStateOfUse}
     * @memberof OtherQaEquipmentDto
     */
    state?: QaEquipmentStateOfUse;
    /**
     * 
     * @type {boolean}
     * @memberof OtherQaEquipmentDto
     */
    isRegistrable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OtherQaEquipmentDto
     */
    identification?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OtherQaEquipmentDto
     */
    $type?: OtherQaEquipmentDtoTypeEnum;
}


/**
 * @export
 */
export const OtherQaEquipmentDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDeviceComponentDtoOtherQaEquipmentDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.OtherQaEquipmentDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type OtherQaEquipmentDtoTypeEnum = typeof OtherQaEquipmentDtoTypeEnum[keyof typeof OtherQaEquipmentDtoTypeEnum];


/**
 * Check if a given object implements the OtherQaEquipmentDto interface.
 */
export function instanceOfOtherQaEquipmentDto(value?: unknown): value is OtherQaEquipmentDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(OtherQaEquipmentDtoTypeEnum)[0];
}

export function OtherQaEquipmentDtoFromJSON(json: any): OtherQaEquipmentDto {
    return OtherQaEquipmentDtoFromJSONTyped(json, false);
}

export function OtherQaEquipmentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OtherQaEquipmentDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': !exists(json, 'creationTime') ? undefined : json['creationTime'],
        'creatorUserId': !exists(json, 'creatorUserId') ? undefined : json['creatorUserId'],
        'lastModificationTime': !exists(json, 'lastModificationTime') ? undefined : json['lastModificationTime'],
        'lastModifierUserId': !exists(json, 'lastModifierUserId') ? undefined : json['lastModifierUserId'],
        'commentCount': !exists(json, 'commentCount') ? undefined : json['commentCount'],
        'commentAttachmentsCount': !exists(json, 'commentAttachmentsCount') ? undefined : json['commentAttachmentsCount'],
        'lastComment': !exists(json, 'lastComment') ? undefined : json['lastComment'],
        'isAvailable': !exists(json, 'isAvailable') ? undefined : json['isAvailable'],
        'origin': !exists(json, 'origin') ? undefined : EntityOriginFromJSON(json['origin']),
        'possibleActions': !exists(json, 'possibleActions') ? undefined : (json['possibleActions'] === null ? null : (json['possibleActions'] as Array<any>).map(PossibleActionDtoFromJSON)),
        'creatorUser': !exists(json, 'creatorUser') ? undefined : UserCatalogDtoFromJSON(json['creatorUser']),
        'lastModifierUser': !exists(json, 'lastModifierUser') ? undefined : UserCatalogDtoFromJSON(json['lastModifierUser']),
        'editingUser': !exists(json, 'editingUser') ? undefined : UserCatalogDtoFromJSON(json['editingUser']),
        'editingTime': !exists(json, 'editingTime') ? undefined : json['editingTime'],
        'comments': !exists(json, 'comments') ? undefined : (json['comments'] === null ? null : (json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : (json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'isReferenced': !exists(json, 'isReferenced') ? undefined : json['isReferenced'],
        'isReferencedBy': !exists(json, 'isReferencedBy') ? undefined : (json['isReferencedBy'] === null ? null : (json['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoFromJSON)),
        'deleterUserId': !exists(json, 'deleterUserId') ? undefined : json['deleterUserId'],
        'deletionTime': !exists(json, 'deletionTime') ? undefined : json['deletionTime'],
        'isDeleted': !exists(json, 'isDeleted') ? undefined : json['isDeleted'],
        'name': json['name'],
        'iuid': !exists(json, 'iuid') ? undefined : json['iuid'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'typeSpecification': !exists(json, 'typeSpecification') ? undefined : json['typeSpecification'],
        'category': RtSystemCategoryFromJSON(json['category']),
        'manufacturer': RtSystemManufacturerFromJSON(json['manufacturer']),
        'model': json['model'],
        'subModel': !exists(json, 'subModel') ? undefined : json['subModel'],
        'imageId': !exists(json, 'imageId') ? undefined : json['imageId'],
        'isArchived': !exists(json, 'isArchived') ? undefined : json['isArchived'],
        'masterDeviceId': !exists(json, 'masterDeviceId') ? undefined : json['masterDeviceId'],
        'withSerialNumber': !exists(json, 'withSerialNumber') ? undefined : WithSerialNumberFromJSON(json['withSerialNumber']),
        'typeNumber': !exists(json, 'typeNumber') ? undefined : json['typeNumber'],
        'brand1': !exists(json, 'brand1') ? undefined : CreateOtherQaEquipmentDtoBrand1FromJSON(json['brand1']),
        'singleDetectorConnectorType': !exists(json, 'singleDetectorConnectorType') ? undefined : CreateOtherQaEquipmentDtoSingleDetectorConnectorTypeFromJSON(json['singleDetectorConnectorType']),
        'deviceInterfaceType': !exists(json, 'deviceInterfaceType') ? undefined : DeviceInterfaceTypeFromJSON(json['deviceInterfaceType']),
        'subCategory': QaEquipmentSubCategoryFromJSON(json['subCategory']),
        'coordinateSystem': !exists(json, 'coordinateSystem') ? undefined : CoordinateSystemFromJSON(json['coordinateSystem']),
        'state': !exists(json, 'state') ? undefined : QaEquipmentStateOfUseFromJSON(json['state']),
        'isRegistrable': !exists(json, 'isRegistrable') ? undefined : json['isRegistrable'],
        'identification': !exists(json, 'identification') ? undefined : json['identification'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function OtherQaEquipmentDtoToJSON(value?: OtherQaEquipmentDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'lastModificationTime': value.lastModificationTime,
        'commentCount': value.commentCount,
        'commentAttachmentsCount': value.commentAttachmentsCount,
        'lastComment': value.lastComment,
        'isAvailable': value.isAvailable,
        'origin': EntityOriginToJSON(value.origin),
        'creatorUser': UserCatalogDtoToJSON(value.creatorUser),
        'lastModifierUser': UserCatalogDtoToJSON(value.lastModifierUser),
        'editingUser': UserCatalogDtoToJSON(value.editingUser),
        'editingTime': value.editingTime,
        'comments': value.comments === undefined ? undefined : (value.comments === null ? null : (value.comments as Array<any>).map(PtwCommentDtoToJSON)),
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : (value.attachments as Array<any>).map(FileMetaInfoDtoToJSON)),
        'isReferenced': value.isReferenced,
        'isReferencedBy': value.isReferencedBy === undefined ? undefined : (value.isReferencedBy === null ? null : (value.isReferencedBy as Array<any>).map(ReferencingObjectDtoToJSON)),
        'name': value.name,
        'iuid': value.iuid,
        'description': value.description,
        'typeSpecification': value.typeSpecification,
        'category': RtSystemCategoryToJSON(value.category),
        'manufacturer': RtSystemManufacturerToJSON(value.manufacturer),
        'model': value.model,
        'subModel': value.subModel,
        'imageId': value.imageId,
        'isArchived': value.isArchived,
        'masterDeviceId': value.masterDeviceId,
        'withSerialNumber': WithSerialNumberToJSON(value.withSerialNumber),
        'typeNumber': value.typeNumber,
        'brand1': CreateOtherQaEquipmentDtoBrand1ToJSON(value.brand1),
        'singleDetectorConnectorType': CreateOtherQaEquipmentDtoSingleDetectorConnectorTypeToJSON(value.singleDetectorConnectorType),
        'deviceInterfaceType': DeviceInterfaceTypeToJSON(value.deviceInterfaceType),
        'subCategory': QaEquipmentSubCategoryToJSON(value.subCategory),
        'coordinateSystem': CoordinateSystemToJSON(value.coordinateSystem),
        'state': QaEquipmentStateOfUseToJSON(value.state),
        'isRegistrable': value.isRegistrable,
        'identification': value.identification,
        '$type': value.$type,
    });
}

